// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__6PNeY","checkboxCol":"Table_checkboxCol__-EirU","emailCol":"Table_emailCol__h6z0L","actionCol":"Table_actionCol__2xqR6"};